import { createRoute } from '@tanstack/react-router';
import { onboarderParentRoute } from 'pages/onboarder/onboarderParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const onboarderPharmaciesRoute = createRoute({
  getParentRoute: () => onboarderParentRoute,
  path: '/pharmacies',
  validateSearch: z.object({
    query: z.string().optional(),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/onboarder/OnboarderPharmaciesPage/OnboarderPharmaciesPage').then((d) => d.Route)
);
